import React from "react"
import PropTypes from "prop-types"
import { SettingsCard, SettingsCardTitle } from "@modules/site/settings"

const propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
}

export default function SettingsSectionCard({ id, title, children, ...rest }) {
  return (
    <SettingsCard id={id} {...rest}>
      <SettingsCardTitle data-cy={`${id}__title`}>{title}</SettingsCardTitle>
      {children}
    </SettingsCard>
  )
}
SettingsSectionCard.propTypes = propTypes
